import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import { getChatPictureSrc } from "@/utils/chat";
import { getPartnerIdFromChatId, isOneToOneChat } from "@/firebase/utils";
import { GetterTypes } from "@/store";
import { ChatTypes } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { useRoute, useRouter } from "vue-router";
import { config } from "@/config";

interface Props {
  image: string;
  id: string | number;
  type?: ChatTypes;
  size?: number;
  disableRedirect?: boolean;
  redirectLink?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileImage',
  props: {
    image: { default: "" },
    id: { default: "" },
    type: { default: ChatTypes.ONE_TO_ONE_CHAT },
    size: { default: 54 },
    disableRedirect: { type: Boolean, default: false },
    redirectLink: { default: "" }
  },
  setup(__props: any) {

const MAITREJA_PROFILE_URL = `${config.api.maitrejaApi.appUrl}/profil/`;

const props = __props;

const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const route = useRoute();
const router = useRouter();

const getProfileLink = (): string => {
  if (props.disableRedirect) return "#";

  if (typeof props.id === "number") return MAITREJA_PROFILE_URL + props.id;

  if (isOneToOneChat(props.id)) {
    const partnerId = getPartnerIdFromChatId(authId.value, props.id);
    return MAITREJA_PROFILE_URL + partnerId;
  }

  if (props.id.length < 10) return MAITREJA_PROFILE_URL + props.id;

  return "#";
};
const redirectToProfile = () => {
  const link = getProfileLink();
  if (props.disableRedirect || link === "#") return;

  if (props.redirectLink) {
    const query = route.query;
    router.push({ path: props.redirectLink, query });
    return;
  }

  if (!window.top) {
    return;
  }
  window.top.location = link;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: {"cursor":"pointer"},
    onClick: redirectToProfile
  }, [
    _createElementVNode("img", {
      class: "profile-image",
      src: _unref(getChatPictureSrc)(_ctx.image, _ctx.type),
      width: _ctx.size,
      height: _ctx.size,
      alt: "profile image",
      style: {"border-radius":"50%","object-fit":"cover"}
    }, null, 8, _hoisted_1)
  ]))
}
}

})